import { Component, inject } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatStepperModule } from '@angular/material/stepper';
import { UIBlockerService } from '@howdeniberia/core-front';
import { IStep } from 'src/app/core/models/front';
import { IMapService } from 'src/app/core/services/api/map';
import { IRisksDataMapService } from 'src/app/core/services/core';
import { RisksListComponent } from '../risks-list/risks-list.component';

@Component({
  selector: 'howden-risks-steps',
  templateUrl: './risks-steps.component.html',
  styleUrls: ['./risks-steps.component.scss'],
  imports: [
    FormsModule,
    ReactiveFormsModule,
    MatStepperModule,
    RisksListComponent
  ]
})
export class RisksStepsComponent {
  private mapSrv = inject(IMapService);
  private uiBlockerSrv = inject(UIBlockerService);
  private dataRiskMapSrv = inject(IRisksDataMapService);

  public steps: IStep[] = [];

  loadSteps(mapToLoad: string | null) {
    this.uiBlockerSrv.block();
    this.mapSrv.getSteps(mapToLoad).subscribe((steps) => {
      this.steps = steps;
      this.uiBlockerSrv.unblock();
      if (mapToLoad !== null) {
        this.getMapData(mapToLoad);
      } else {
        this.checkUnfinishedMap();
      }
    });
  }

  checkFullFlow(): boolean {
    if (this.steps.length > 0) {
      if (this.steps.filter(x => x.complete).length === this.steps.length) {
        return true;
      }
    }
    return false;
  }

  private getMapData(mapId: string) {
    this.uiBlockerSrv.block();
    this.mapSrv.get(mapId).subscribe((mapData) => {
      this.uiBlockerSrv.unblock();
      this.dataRiskMapSrv.loadDataRiskMap(mapData);
    });
  }

  private checkUnfinishedMap() {
    this.uiBlockerSrv.block();
    this.mapSrv.getUnfinishedMap().subscribe((mapData) => {
      this.uiBlockerSrv.unblock();
      if (mapData && mapData.riskRatings.length > 0) {
        const question: string = $localize`: @@app.risks-evaluation.load-map-data.message: Hay datos almacenados de un mapa realizado anteriormente\r\n ¿Desea recuperarlos?`;
        if (confirm(question)) {
          this.dataRiskMapSrv.loadDataRiskMap(mapData);
        } else {
          this.dataRiskMapSrv.cleanDataRiskMap();
        }
      } else {
        this.dataRiskMapSrv.cleanDataRiskMap();
      }
    });
  }
}
